import React, { useContext, useEffect, useState } from "react";
import Logo from "../Assets/Group 8 3.png";
import UpperArrow from "../Assets/UpperArrow.svg";
import profileSVG from "../Assets/profileSVG.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Get_Api } from "../ApiUrls";
import { CategoryContext } from "./CategoryProvider";
import Header from "./Header";

const Navbar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const { setSelectedCategory, selectedCategory, allCategories } = useContext(CategoryContext);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const navigateto = (data) => {
        navigate(`/${data}`)
    }

    const [isLoggedIn, setIsLoggedIn] = useState(false);


    useEffect(() => {
        const storedUser = localStorage.getItem("user") || {};
        const storedToken = localStorage.getItem("userToken");
        if (storedUser && storedToken) {
            setIsLoggedIn(true);
        }
    }, []);

    const [IsUploading, setIsUploading] = useState(false);


    const OntoPage = (page, categoryId) => {
        if (categoryId) {
            setSelectedCategory(categoryId);
        }
        navigate(`/${page}`);
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            <Header />
            <nav className="navbar">
                <div className="navbar-logo">
                    <img src={Logo} alt="ADL Logo" />
                </div>
                <div className="menu-toggle" onClick={toggleMenu}>
                    ☰
                </div>
                <ul className={`navbar-links ${menuOpen ? "active" : ""}`}>
                    <li
                        className={location.pathname === "/" ? "active" : ""}
                        onClick={() => { navigateto('') }}>
                        Home
                    </li>
                    <li
                        className={location.pathname === "/AboutUs" ? "active" : ""}
                        onClick={() => { navigateto('AboutUs') }}>
                        About Us
                    </li>
                    {allCategories?.map((category, index) => (
                        <li key={index}
                            className={selectedCategory === category?._id ? "active" : ""}
                            onClick={() => { OntoPage('Properties', category?._id) }}>
                            {category?.Name}
                        </li>
                    ))}
                    <li
                        className={location.pathname === "/Blogs" ? "active" : ""}
                        onClick={() => { navigateto('Blogs') }}>
                        Blog
                    </li>
                    <li
                        className={location.pathname === "/ContactUs" ? "active" : ""}
                        onClick={() => { navigateto('ContactUs') }}>
                        Contact Us
                    </li>
                </ul>
                <div className="navbar-contact">
                    <button onClick={() => { navigateto('AddProperty') }} className="contact-button">
                        Add Property
                    </button>
                    {/* <button onClick={() => { navigateto('ContactUs') }} className="contact-button">
                    Contact Us
                </button> */}

                    {isLoggedIn ?
                        <Link to="/Profile">
                            <img src={profileSVG} alt="Profile" />
                        </Link>
                        :
                        <button onClick={() => { navigateto('login') }} className="contact-button2">
                            Login
                        </button>
                    }

                </div>
            </nav>
        </>
    );
};

export default Navbar;
